export const SET_TABLECOLUMN = 'SET_TABLECOLUMN';

export function setTableColumnFilter(tableFilter) {
  return {
    type: SET_TABLECOLUMN,
    tableFilter,
  };
}
